import { render, staticRenderFns } from "./RollStatistics.vue?vue&type=template&id=1d25c2e4&scoped=true&"
import script from "./RollStatistics.vue?vue&type=script&lang=js&"
export * from "./RollStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RollStatistics.vue?vue&type=style&index=0&id=1d25c2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d25c2e4",
  null
  
)

export default component.exports